import { createFileRoute } from "@tanstack/react-router";
import AdminSettingsPage from "@/pages/admin/settings";

export const Route = createFileRoute("/app/admin/settings")({
  component: AdminSettingsPage,
});
